var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webhooks-2---option-1",
    transform: "translate(-302.000000, -1627.000000)",
    fill: "#6E6E6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forms/Form-SearchField",
    transform: "translate(292.000000, 1617.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7,18.3 L16.6,15.2 L16.6,15.2 C17.5,14 18,12.6 18,11 C18,7.1 14.9,4 11,4 C7.1,4 4,7.1 4,11 C4,14.9 7.1,18 11,18 C12.6,18 14,17.5 15.2,16.6 L15.2,16.6 L18.3,19.7 C18.5,19.9 18.8,20 19,20 C19.3,20 19.5,19.9 19.7,19.7 C20.1,19.3 20.1,18.7 19.7,18.3 L19.7,18.3 Z M11,16 C8.2,16 6,13.8 6,11 C6,8.2 8.2,6 11,6 C13.8,6 16,8.2 16,11 C16,13.8 13.8,16 11,16 L11,16 Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search.e4b951ccbf9abe316bd985b0b07b4d62.svg";